import { fromJS } from 'immutable';
import normaliseResponse from 'utils/normaliseResponse';

import * as constants from 'actions/users/constants';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_USERS_SUCCESS: {
      const { projectId, users } = action;

      const mappedUsers = users.map(({ roles, ...props }) => ({
        ...props,
        role: roles[0]
      }));

      const prevAllIds = state.get('allIds') || [];

      const normalisedResponse = normaliseResponse(mappedUsers);
      const { byId } = normalisedResponse;
      const allIdsByProject = normalisedResponse.allIds;
      const allIds = prevAllIds.concat(
        allIdsByProject.filter((id) => prevAllIds.indexOf(id) < 0)
      );

      return state
        .setIn(['byId'], fromJS(byId))
        .set('allIds', fromJS(allIds))
        .setIn(['byProjectId', `${projectId}`], fromJS(allIdsByProject));
    }

    default:
      return state;
  }
};
